import { Link, NavLink, useLocation } from 'react-router';

import ambarIcon from '../../assets/images/ambarIcon.svg';
import enterIcon from '../../assets/images/enterIcon.svg';
import plusIcon from '../../assets/images/plusIcon.svg';
import questionIcon from '../../assets/images/questionIcon.svg';
import sidebarLinkIcon from '../../assets/images/sidebarLinkIcon.svg';
import supportIcon from '../../assets/images/supportIcon.svg';
import LoginHeader from '../LoginHeader/LoginHeader';
import styles from './styles/styles.module.css';

function SidebarInfoBlock() {
  // const styleInfo = pathname.includes('/menu') && width < 480?
  //   styles.sidebarInfoWrapperDis :
  //   styles.sidebarInfoWrapper;
  const { pathname } = useLocation();
  const isLoginMenu = pathname.includes('/login/menu');

  const styleInfo = styles.sidebarInfoWrapper;
  return (
    <div className={styleInfo}>
      {pathname.includes('/login/menu') ? (
        <div style={{ width: '100vw' }}>
          <LoginHeader />
        </div>
      ) : null}
      <div className={styles.sidebarInfoSupport}>
        {isLoginMenu ? '' : <h3 className={styles.sidebarInfoTitle}>есть вопрос?</h3>}
        <ul className={styles.navLinks}>
          <li>
            <NavLink
              to={isLoginMenu ? '/registration' : '/faq'}
              className={`${styles.infoLink} ${styles.infoLocationLink}`}
            >
              <img
                src={isLoginMenu ? plusIcon : questionIcon}
                alt="иконка вопрос"
                className={styles.sidebarIcons}
              />
              <p className={`${styles.sidebarInfoText} ${styles.sidebarInfoText_medium}`}>
                {isLoginMenu ? 'Регистрация' : 'Помощь'}
              </p>
            </NavLink>
          </li>
          <li>
            <NavLink
              to={isLoginMenu ? '/login' : '/contacts'}
              className={`${styles.infoLink} ${styles.infoLocationLink}`}
            >
              <img
                src={isLoginMenu ? enterIcon : supportIcon}
                alt="иконка поддержка"
                className={styles.sidebarIcons}
              />
              <p className={`${styles.sidebarInfoText} ${styles.sidebarInfoText_medium}`}>
                {isLoginMenu ? 'Вход' : 'Связь с поддержкой'}
              </p>
            </NavLink>
          </li>
        </ul>
      </div>
      <div
        className={`${styles.sidebarInfoСontacts} ${styles.sidebarInfoSupport}`}
        style={pathname.includes('menu') ? { paddingTop: '0vh' } : {}}
      >
        <h3 className={styles.sidebarInfoTitle}>Контакты</h3>
        <ul className={styles.navLinks}>
          <li>
            <Link
              className={`${styles.infoLink} ${styles.contactLink}`}
              to="tel:+74994606716"
              target="_blank"
              rel="noopener"
            >
              <p className={styles.sidebarInfoText}>+7 (499) 460-67-16</p>
            </Link>
          </li>
          <li>
            <Link
              to="https://yandex.ru/map-widget/v1/?um=constructor%3A14f98850e5b7a1234819d87bbbb628a32bd21d8754c845ce62fb74d27e1015f1"
              className={`${styles.infoLink} ${styles.infoLocationWrapper}`}
              target="_blank"
              rel="noopener"
            >
              <img src={sidebarLinkIcon} alt="иконка локации" />
              <p className={`${styles.sidebarInfoText} ${styles.infoLocationText}`}>
                Адрес склада: г.&nbsp;Москва, г.&nbsp;Троицк, ул.&nbsp;Промышленная, 15
              </p>
            </Link>
          </li>
          <li>
            <Link
              to="https://ambar-sklad.ru/"
              className={styles.infoLink}
              target="_blank"
              rel="noopener"
            >
              <img src={ambarIcon} alt="иконка логотипа" />
              <p className={`${styles.sidebarInfoText} ${styles.infoLocationText}`}>
                ambar-sklad.ru
              </p>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SidebarInfoBlock;
